import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    transition: 'background 300ms ease',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    paddingLeft: '1rem',
    paddingTop: '0.3rem',

    width: '100%',
    height: '100%',

    minHeight: '2.75rem',
    maxHeight: '2.75rem',

    '&:hover': {
      backgroundColor: `${getRGBA('#0F0F1E', 0.08)} !important`,
    },
  },

  rootExtended: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'background 300ms ease',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    paddingLeft: '1rem',
    paddingTop: '0.3rem',

    width: '100%',
    height: '100%',

    minHeight: '2.75rem',
    maxHeight: '2.75rem',

    '& h1': {
      flexGrow: 1,
      fontFamily: 'Nunito',
      fontSize: '1rem',
      marginLeft: '1rem',
      marginBottom: '1.6rem',
      fontWeight: '400',
      userSelect: 'none',
      cursor: 'pointer',
      textTrasform: 'capitalize',
      color: '#191C1A',
    },

    '&:hover': {
      backgroundColor: `${getRGBA('#0F0F1E', 0.08)} !important`,
      cursor: 'pointer',

      icon: {
        color: '#0F0F1E',
      },
    },

    '& .MuiSvgIcon-root': {
      color: '#0F0F1E',
    },
  },

  rootDisabled: {
    opacity: '0.5',
    pointerEvents: 'none',
  },

  rootActive: {
    backgroundColor: `${getRGBA('#0F0F1E', 0.08)} !important`,

    '& .MuiSvgIcon-root': {
      color: '#0F0F1E',
    },
  },

  rootActiveExtended: {
    backgroundColor: `${getRGBA('#0F0F1E', 0.08)} !important`,
    cursor: 'pointer',
  },

  icon: {
    cursor: 'pointer',
    userSelect: 'none',
    height: '2.5rem !important',
    fontSize: '1.5rem !important',

    '& .MuiSvgIcon-root, & .MuiIcon-root, & .svg': {
      color: '#0F0F1E',
      fontSize: '1.5rem !important',
    },
  },

  mainIcon: {
    paddingTop: '0.3rem',
  },

  arrowIcon: {
    height: '1.75rem !important',
    opacity: '0',
    marginBottom: '0.15rem',
    marginRight: '0.15rem',
  },

  arrowEnabled: {
    opacity: '1',
  },
}))

export { useStyles }
